import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useBrand } from "@webuild-ai/react-auth";

import { title, subtitle } from "@/components/primitives";
import MenuCard from "@/components/MenuCard/MenuCard";
import { useTheme } from "@/hooks/use-theme";

export default function IndexPage() {
  const { t } = useTranslation();
  const { brand } = useBrand();

  const { theme } = useTheme();

  // Redirect to dashboard if configured as the default landing page
  // but only if showInSideBar is false (dashboard should be accessed via sidebar instead)
  if (brand.dashboard?.url && !brand.dashboard.showInSideBar) {
    return <Navigate replace to={`/${brand.dashboard?.urlSegment ?? "dashboard"}`} />;
  }

  const BrandLogo = theme === "dark" && brand.logoDark ? brand.logoDark : brand.logo;

  return (
    <>
      <section className="flex flex-col items-center justify-center gap-4 py-4">
        <div className="flex flex-col items-center justify-center text-center title-section w-full">
          {brand.showLogo ? (
            <BrandLogo className="mx-auto" size={brand.menuItemsIconSize || 60} />
          ) : (
            <span className={title()}>{brand.name}&nbsp;</span>
          )}
          <br />
          <div className={subtitle({ class: `${!brand.showLogo ? "mt-4" : ""}` })}>
            {t(brand.subtitle)}
          </div>
        </div>
        <MenuCard />
      </section>
    </>
  );
}
